module.exports = __webpack_public_path__ + "img/m-jiekuan.9479d4a5.svg";